import { render, staticRenderFns } from "./BInputField.vue?vue&type=template&id=cd6f3254"
import script from "./BInputField.vue?vue&type=script&setup=true&lang=ts"
export * from "./BInputField.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports